import { useEffect, useState } from 'react';
import { getTaskForm } from '../../api/getTaskFormApiService';
import { mapApiFormToBuilderState } from '../../utils/mapApiFormToBuilderState';
import type { FormBuilderState, TaskFormDetailResponse } from '../../types';

export function useViewForm(id: string) {
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState<TaskFormDetailResponse | null>(null);
  const [formBuilderState, setFormBuilderState] =
    useState<FormBuilderState | null>(null);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setNotFound(false);
    setError('');

    getTaskForm(id).then((result) => {
      if (!mounted) {
        return;
      }
      if (result.success && result.data) {
        setForm(result.data);
        setFormBuilderState(mapApiFormToBuilderState(result.data));
      } else if (result.notFound) {
        setNotFound(true);
      } else {
        setError(result.error ?? '');
      }
      setLoading(false);
    });

    return () => {
      mounted = false;
    };
  }, [id]);

  return { loading, form, formBuilderState, notFound, error };
}
